import $ from 'jquery'

function scrollTo(scrollTop, duration = 200) {
  $('html, body').animate({ scrollTop }, duration)
}

function replaceSpacesWithWildcards(searchText) {
  const wildCard = '*'
  if(!searchText) {
    return wildCard
  }
  return wildCard + searchText.replace(/\s+/g, '*') + wildCard
}

function nl2br(str) {
  var breakTag = '<br />'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + breakTag + '$2')
}

export default { scrollTo, replaceSpacesWithWildcards, nl2br }
